import GameAPi from '../../api/game-occurence-api'
import GameModel from '../../api/game-model'
import logger from '../../logging'

export default {
  namespaced: true,
  state: {
    token: "",
    apiMessage: "",
    game: {},
    gameOccurrence: {},
    teamAnswers: {},
    webSocketConnection: {},
    connectionState: GameModel.ConnectionState.UNKNOWN,
    gameClientState: GameModel.GameClientState.READY_WAITING,
    teams: []
  },
  getters: {
    token: state => {
      if (state.token === "") {
        let token = localStorage.getItem('hostToken');
        if (token) {
          state.token = token
        }
      }
      return state.token;
    },
    // sortedTeams: state => {
    //   let sortedteams = state.teams.sort((a,b) => b.totalEarnedPoints - a.totalEarnedPoints);
    //   return sortedteams;
    // }
  },
  mutations: {
    updateHostToken(state, token) {
      state.token = token;
      localStorage.setItem('hostToken', token);
    },
    updateGameDetails(state, game) {
      state.game = game;
    },
    updateGameOccurrence(state, gameOccurrence) {
      state.gameOccurrence = gameOccurrence;
    },
    updateCurrentCategory(state, currentCategoryId){
      state.gameOccurrence.currentCategoryId = currentCategoryId;
    },
    updateCurrentQuestion(state, currentQuestionId){
      state.gameOccurrence.currentQuestionId = currentQuestionId;
    },
    updateApiMessage(state, message) {
      state.apiMessage = message;
    },
    updateTeamAnswers(state, teamAnswers) {
      state.teamAnswers = teamAnswers;
    },
    updateConnectionState(state, newState) {
      state.connectionState = newState;
    },
    updateGameClientState(state, gameClientState) {
      state.gameClientState = gameClientState;
    },
    updateRevealedScore(state, revealedScore) {
      revealedScore.forEach(teamScore => {
        let team = state.teams.find(t => t.teamId === teamScore.teamId);
        if (team) {
          team.totalEarnedPoints = teamScore.totalEarnedPoints;
        }
      });
      state.teams.sort((t1, t2) => t1.totalEarnedPoints < t2.totalEarnedPoints ? 1 : -1);
    },
    sortTeams(state){
      state.teams.sort((t1, t2) => t1.totalEarnedPoints < t2.totalEarnedPoints ? 1 : -1);
    },
    updateWebSocketConnection(state, connection) {
      state.webSocketConnection = connection;
    },
    teamConnected(state, team) {
      let existingTeam = state.teams.find(t => t.teamId === team.teamId);

      if (!existingTeam) {
        team.status = "Idle";
        team.totalEarnedPoints = team.totalEarnedPoints ? team.totalEarnedPoints : 0;
        state.teams.push(team);
      } else {
        existingTeam.totalEarnedPoints = team.totalEarnedPoints;
      }
    },
    teamJoined(state, team) {

    },
    teamAnswersSubmitted(state, teamId) {
      let team = state.teams.find(t => t.teamId === teamId);

      if (team) {
        team.status = "Answers Submitted"
      }
    },
    setTeamsIdle(state) {
      state.teams.forEach(t => t.status = "Idle");
    },
    setTeamsWaiting(state) {
      state.teams.forEach(t => t.status = "Waiting...");
    }
  },
  actions: {
    async joinGame({
      commit,
      state
    }, {
      code,
      adminToken
    }) {
      let response = await GameAPi.joinGameAsHost(code, adminToken);

      if (response.success) {
        commit('updateHostToken', response.token);
        commit('updateGameDetails', response.gameDetails);
        let gameOccurrence = response.gameDetails.occurrences.find(o => o.code === code);
        commit('updateGameOccurrence', gameOccurrence);
      } else {
        commit('updateApiMessage', response.message);
      }
    },
    async acceptRegistrations({
      commit,
      state,
      getters
    }) {
      await GameAPi.acceptRegistrations(state.gameOccurrence.gameOccurrenceId, getters.token);
      commit('updateGameClientState', GameModel.GameClientState.ACCEPTING_REGISTRATIONS);
    },
    async introduceCategory({
      commit,
      state,
      getters
    }, categoryId) {
      await GameAPi.introduceCategory(state.gameOccurrence.gameOccurrenceId, categoryId, getters.token);
      commit('updateGameClientState', GameModel.GameClientState.INTRODUCE_CATEGORY);
      commit('updateCurrentCategory', categoryId);
      commit('updateCurrentQuestion', 0);
    },
    async introduceQuestion({
      commit,
      state,
      getters
    }, questionId) {
      await GameAPi.introduceQuestion(state.gameOccurrence.gameOccurrenceId, questionId, getters.token);
      commit('updateGameClientState', GameModel.GameClientState.INTRODUCE_QUESTION);
      commit('updateCurrentQuestion', questionId);
    },
    async awaitingTeamAnswers({
      commit,
      state,
      getters
    }, questionId) {
      await GameAPi.awaitingTeamAnswers(state.gameOccurrence.gameOccurrenceId, questionId, getters.token);
      commit('updateGameClientState', GameModel.GameClientState.AWAITING_TEAM_ANSWERS);
    },
    async resendQuestion({
      commit,
      state,
      getters
    }, {questionId, teamName}) {
      await GameAPi.resendQuestion(state.gameOccurrence.gameOccurrenceId, questionId, teamName, getters.token);
    },
    async revealCategoryScores({
      commit,
      state,
      getters
    }, categoryId) {
      await GameAPi.revealCategoryScores(state.gameOccurrence.gameOccurrenceId, categoryId, getters.token);
      commit('updateGameClientState', GameModel.GameClientState.REVEAL_CATEGORY_SCORES);
      commit('updateCurrentQuestion', 0);
    },
    async revealFinalScores({
      commit,
      state,
      getters
    }) {
      await GameAPi.revealFinalScores(state.gameOccurrence.gameOccurrenceId, getters.token);
      commit('updateGameClientState', GameModel.GameClientState.REVEAL_FINAL_SCORES);
      commit('updateCurrentCategory', 0);
      commit('updateCurrentQuestion', 0);
    },
    async getTeamAnswers({
      commit,
      state,
      getters
    }, {
      gameOccurrenceId,
      questionId
    }) {
      let response = await GameAPi.getTeamAnswers(gameOccurrenceId, questionId, getters.token);

      if (response.success) {
        commit('updateTeamAnswers', response.teamAnswers);
      } else {
        commit('updateApiMessage', response.message);
      }
    },
    async saveTeamAnswerScores({
      commit,
      state,
      getters
    }, {
      gameOccurrenceId,
      teamScores
    }) {
      await GameAPi.saveTeamAnswerScores(gameOccurrenceId, teamScores, getters.token);
    },
    async connectWebSocket({
      commit,
      state,
      dispatch
    }) {
      commit('updateConnectionState', GameModel.ConnectionState.CONNECTING);
      let connection = await GameAPi.createWebSocket(state.token, "host",
        (category) => {
          commit('updateGameClientState', GameModel.GameClientState.INTRODUCE_CATEGORY);
          commit('setTeamsIdle');
        }, (question) => {
          commit('updateGameClientState', GameModel.GameClientState.INTRODUCE_QUESTION);
          commit('setTeamsIdle');
        }, () => {
          commit('updateGameClientState', GameModel.GameClientState.AWAITING_TEAM_ANSWERS);
          commit('setTeamsWaiting');
        }, (revealedCategoryScore) => {
          commit('updateRevealedScore', revealedCategoryScore);
          commit('updateGameClientState', GameModel.GameClientState.REVEAL_CATEGORY_SCORES);
          commit('setTeamsIdle');
        }, (finalScore) => {
          commit('updateRevealedScore', finalScore);
          commit('updateGameClientState', GameModel.GameClientState.REVEAL_FINAL_SCORES);
          commit('setTeamsIdle');
        },
        (team) => {
          commit('teamConnected', team);
        },
        (team) => {
          commit('teamJoined', team);
        }, (teamId) => {
          commit('teamAnswersSubmitted', teamId);
        }, () => {
          commit('updateGameClientState', GameModel.GameClientState.ACCEPTING_REGISTRATIONS);
        });

        commit('updateWebSocketConnection', connection);
        await dispatch('startWebSocket');
  
        commit('updateConnectionState', GameModel.ConnectionState.CONNECTED);
        commit('updateGameClientState', GameModel.GameClientState.READY_WAITING);
  
        connection.onclose(async () => {
          await dispatch('startWebSocket');
        });
    },
    async startWebSocket({
      commit,
      state,
      dispatch
    }) {
      commit('updateConnectionState', GameModel.ConnectionState.DISCONNECTED);
      try {
        await GameAPi.connectWebSocket(state.webSocketConnection);
        commit('updateConnectionState', GameModel.ConnectionState.CONNECTED);
      } catch (err) {
        logger.error(err);
        setTimeout(async () => await dispatch('startWebSocket'), 2000);
      }
    },
    async refreshTeams({
      commit,
      state,
      getters
    }, {
      gameOccurrenceId
    }){
        let teams = await GameAPi.getAllTeams(gameOccurrenceId, getters.token);
        teams.forEach(t=> commit('teamConnected', t));
        commit('sortTeams');
        
    }
  }
}